import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";
import Swal from 'sweetalert2';

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.css']
})
export class AddClientComponent implements OnInit {
  ClientName = "";
  Province = "";
  Area = "";
  ClientCellNumber = "";

  Provinces = [""];
  Areas = [""];

  PossibleClient = "";
  PossibleClientMain = [""];
  PossibleClients = [""];

  NewClientList = [""];
  NewClientListCellNumbers = [""];


  constructor(private dbService: SqlService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal) { }

  @Input() PreselectedProvince: string | undefined;
  @Input() PreselectedArea: string | undefined;
  @Input() AlloCateClientPopupVersion: string | undefined;

  ngOnInit(): void {
    this.getData();
    this.NewClientList.splice(0);
    this.NewClientListCellNumbers.splice(0);
  }

  async getData() {
    Swal.fire({
      title: 'Loading Provinces',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    await (this.dbService.getAllProvinces().subscribe((ret: any) => {
      if (ret != "false") {
        this.Provinces.splice(0);
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          this.Provinces.push(element);
        });

        if (this.AlloCateClientPopupVersion == "true" && this.PreselectedProvince != "" && this.PreselectedProvince != undefined) {
          this.Province = this.PreselectedProvince;
          this.ProvinceChanged();
        }
      } else {
        this.PopupTitle = "Something went wrong"
        this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
      }

      Swal.close();
    }));
  }

  async ProvinceChanged() {
    Swal.fire({
      title: 'Loading Areas',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.Area = "";
    await (this.dbService.getAreaPerProvince(this.Province).subscribe((ret: any) => {
      this.Areas.splice(0);
      if (ret != "false") {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          this.Areas.push(element);
        });

        if (this.AlloCateClientPopupVersion == "true" && this.PreselectedArea != "" && this.PreselectedArea != undefined) {
          this.Area = this.PreselectedArea;
          this.AreaNameChanged();
        }
      } else {
        //alert("Please check your connection and try again");
      }
      Swal.close();
    }));
  }

  AddMoreClients() {
   console.log(this.ClientName)
    if (this.NewClientList.indexOf(this.ClientName) != -1) {
      this.PopupTitle = "Duplicated entry"
      this.DisplayErrormessage = "This client name is already in the list to be added.";
      let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
      element.click();
    } else {
      this.NewClientList.push(this.ClientName);
      this.NewClientListCellNumbers.push(this.ClientCellNumber);
    }
  }

  RemoveSpecificClient(indexOfClient: number) {
    this.NewClientList.splice(indexOfClient, 1);
    this.NewClientListCellNumbers.splice(indexOfClient, 1);
  }


  async Save() {

    if (this.NewClientList.length > 0) {
      if (this.NewClientList.indexOf(this.ClientName) == -1) {
        this.NewClientList.push(this.ClientName);
        this.NewClientListCellNumbers.push(this.ClientCellNumber);
      } 

      var formData = new FormData(); // Currently empty
      var tempSqlStatement = "INSERT INTO [Pactel].[dbo].[Clients](Client, Province, Area,cCellNumber) VALUES";

      this.NewClientList.forEach((element, index) => {
        tempSqlStatement += " ('"+element+"','"+this.Province+"','"+this.Area+"','"+this.NewClientListCellNumbers[index]+"'),";
      });
      tempSqlStatement = tempSqlStatement.substring(0 , tempSqlStatement.length -1);
      formData.set('SQLStatement', tempSqlStatement + ";");
      console.log(tempSqlStatement);

      await (this.dbService.AddMultipleClients(formData).subscribe((ret: any) => {
        if (!(String(ret).includes("Error"))) {
          this.PopupTitle = "Success"
          this.DisplayErrormessage = "The Client has been Added";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
          this.Reset();
        } else {
          if ((String(ret).includes("Duplicate entry")) || (String(ret).includes("duplicate key"))) {
            this.PopupTitle = "Invalid Details"
            this.DisplayErrormessage = "This Client already exists";
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
          } else {
            this.PopupTitle = "Something went wrong"
            this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
          }
  
        }
      }));
    } else {
      await (this.dbService.AddClient(this.ClientName, this.Province, this.Area, this.ClientCellNumber).subscribe((ret: any) => {
        if (!(String(ret).includes("Error"))) {
          this.PopupTitle = "Success"
          this.DisplayErrormessage = "The Client has been Added";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
          this.Reset();
        } else {
          if ((String(ret).includes("Duplicate entry")) || (String(ret).includes("duplicate key"))) {
            this.PopupTitle = "Invalid Details"
            this.DisplayErrormessage = "This Client already exists";
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
          } else {
            this.PopupTitle = "Something went wrong"
            this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
          }

        }
      }));
    }

  }

  Reset() {
    this.ClientName = "";
    this.Province = "";
    this.Area = "";
    this.ClientCellNumber = "";
    this.Areas.splice(0);
    this.NewClientList.splice(0);
    this.NewClientListCellNumbers.splice(0);
  }

  Back() {
    this.router.navigate(['ViewClient']);
  }




  PossibleClientChanged() {
    this.ClientName = this.PossibleClient[0];
  }

  async AreaNameChanged() {
    Swal.fire({
      title: 'Loading Clients',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.PossibleClientMain.splice(0);
    this.PossibleClients.splice(0);


    if (this.Province != "") {
      var formData = new FormData(); // Currently empty 
      formData.set("Province", this.Province + "' AND Area='" + this.Area);


      await (this.dbService.getClientsPerProvince(formData).subscribe((ret: any) => {
        if (!(String(ret).includes("Error"))) {

          if (!(String(ret) == "false")) {
            let a = (ret as string).split(';');
            a.forEach(element => {
              this.PossibleClientMain.push(element.split(',')[0]);

            });

            this.ClientNameChanged();
          }


        } else {

          this.PopupTitle = "Something went wrong"
          this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();

        }
        Swal.close();
      }));
    }
  }

  ClientNameChanged() {
    this.PossibleClients.splice(0);

    for (let index = 0; index < this.PossibleClientMain.length; index++) {
      if (this.PossibleClientMain[index].indexOf(this.ClientName) > -1) {
        this.PossibleClients.push(this.PossibleClientMain[index]);
      }

    }

  }



  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";
  open(content: any) {
    console.log("HI");
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
        //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        //element.click();
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
